module.exports = __webpack_public_path__ + "resources/delete-9436ff083c3f2bf87470fd96be5d034b.svg";